import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import ConversationDropdown from '../ConversationDropdown';
import { stripHtml } from '../../utils/stripHtml'; // Import the utility function

const ConversationItem = ({ conversation, onConversationClick, onCollectionUpdated, onUpdateCollection, onConversationDeleted }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const truncateContent = (content, wordLimit = 50) => {
    const strippedContent = stripHtml(content); // Remove HTML tags
    const words = strippedContent.split(/\s+/);
    if (words.length > wordLimit) {
      return words.slice(0, wordLimit).join(' ') + '...';
    }
    return strippedContent;
  };

  return (
    <div className="py-4 border-b border-border-light relative transition-all duration-200 hover:bg-gray-50 rounded-lg -mx-2 px-2">
      <h3
        className="text-lg font-semibold cursor-pointer text-text-primary hover:text-primary transition-colors duration-200"
        onClick={onConversationClick}
      >
        {conversation.title}
      </h3>
      <p
        className="text-text-detail cursor-pointer mt-1 line-clamp-2 hover:text-text-primary transition-colors duration-200"
        onClick={onConversationClick}
      >
        {truncateContent(conversation.messages[conversation.messages.length - 1]?.content || '')}
      </p>
      <div className="flex justify-between items-center mt-3">
        <span className="text-text-muted text-sm">
          {new Date(conversation.updatedAt || conversation.createdAt).toLocaleDateString()}
        </span>
        <div className="flex space-x-2">
          <button 
            className="bg-background-card rounded-lg text-text-muted hover:bg-gray-200 hover:text-text-primary transition-all duration-200 hover:shadow-sm active:transform active:scale-95 flex items-center justify-center w-8 h-8"
            onClick={(e) => {
              e.stopPropagation();
              setShowDropdown(!showDropdown);
            }}
          >
            <FontAwesomeIcon icon={faEllipsisV} />
          </button>
        </div>
      </div>
      {showDropdown && (
        <ConversationDropdown 
          conversationId={conversation._id}
          onClose={() => setShowDropdown(false)}
          onCollectionUpdated={onCollectionUpdated}
          onUpdateCollection={onUpdateCollection}
          onConversationDeleted={onConversationDeleted}
        />
      )}
    </div>
  );
}

export default ConversationItem;